import { Translation } from '@ps/web-shared-components';

import { Deposit } from '../Deposit/Deposit';
import { VerifyAccount } from '../VerifyAccount/VerifyAccount';

import {
  TXTWCL_N0_steps_left,
  TXTWCL__Complete_your_profile_
} from './RMFCompletedButtonsGroup.messages.json';
import { contentContainer, header, secondaryText } from './RMFCompletedButtonsGroup.scss';

const RMFCompletedButtonsGroup: React.FC = () => (
  <div className={contentContainer}>
    <div className={header}>
      <strong>
        <Translation {...TXTWCL__Complete_your_profile_} />
      </strong>
      <h3 className={secondaryText}>
        <Translation {...TXTWCL_N0_steps_left} values={{ 0: 2 }} />
      </h3>
    </div>
    <VerifyAccount />
    <Deposit />
  </div>
);

export default RMFCompletedButtonsGroup;
